<template>
  <div class="bd">
    <ul class="newslist">
      <li v-for="(item,index) in dataList" :key="index" @click="toDetail(item.id)">
        <div class="flex_item"><a href="javascript:;">{{item.title}}</a></div>

        <span v-if="!boolTime(item.endTime)">{{item.endTime}}</span>
        <button v-else type="button" class="btn" @click.stop.prevent="navTo(item.id)">我要申请</button>
      </li>
    </ul>

    <el-pagination
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pageNum"
        :page-size="pageSize"
        layout="prev, pager, next, jumper"
        :total="total"
    >
    </el-pagination>
  </div>
</template>

<script>
//日期列表模型组件

import {parseTime} from "@/libs/utils";

export default {
  props:{
    id:{
      type:[String,Number],
      default:0
    },
    columnId:{
      type:[String,Number],
      default:0
    },
    pid:{
      type:[String,Number],
      default:0
    },
    column:{
      type:Object,
      default(){
        return {}
      }
    }
  },
  filters:{
    format(x){
      return x.split(" ")[0]
    }
  },
  data(){
    return {
      dataList:[],
      pageNum: 1,
      pageSize: 20,
      total: 0,
    }
  },
  mounted() {
    this.getList()
  },
  methods:{
    parseTime,
    boolTime(date){
      let listDate = new Date(date);
      let now = new Date();
      return now - listDate
    },
    async getList(){
      let res = await this.$api.getArticleListById({
        pageNum:this.pageNum,
        pageSize:this.pageSize,
        id:this.id
      })
      this.dataList = res.data.data.list
      this.total = res.data.data.total
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.pageNum = val;
      this.getList();
    },
    getText(str){
      let res = str.replace(/[^\u4e00-\u9fa5]/gi, "")
      if(res.length > 80){
        res = res.slice(0,80) + '...'
      }
      return res
    },
    toDetail(id){
      this.$router.push(`/contents/${this.pid}/${this.columnId}/${id}.html?apply=`+true)
    },
    navTo(id){
      this.$router.push('/channels/374/393.html?planId='+id)
    }
  },
}
</script>

<style scoped>
ul{
  margin-bottom: 30px;
}
ul li{
  display: flex;
  align-items: center;

}
.btn{
  font-size: 14px;
  width: 80px;
  height: 26px;
  border-radius: 34px;
  display: block;
  background: #244991;
  color: #fff;
}
</style>
